import { useContext } from "react"
import { useMutation } from "react-apollo"

import { SessionContext } from "contexts/session"

import { queryOptions } from "utils/helper"

import CREATE_USER from "../../graphql/UserManagement/mutations/createUser"

const useCreateUserMutation = options => {
  const { user } = useContext(SessionContext)

  return useMutation(CREATE_USER, {
    ...queryOptions(user, true),
    ...options,
    refetchQueries: ['AllUsers'],
  });
}

export default useCreateUserMutation
